const readEnvVariable = (key: keyof typeof window.__env) =>
  process.env[key] || window.__env?.[key];

export const env = {
  apiUrl: `${readEnvVariable('REACT_APP_API_HOST')}/api`,
  dataApiUrl: readEnvVariable('REACT_APP_DATA_API_URL'),
  publicApiUrl: readEnvVariable('REACT_APP_PUBLIC_API_URL'),
};
